import { render, staticRenderFns } from "./mainDialog.vue?vue&type=template&id=108b78bc&scoped=true&"
import script from "./mainDialog.vue?vue&type=script&lang=js&"
export * from "./mainDialog.vue?vue&type=script&lang=js&"
import style0 from "./mainDialog.vue?vue&type=style&index=0&id=108b78bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108b78bc",
  null
  
)

export default component.exports